<!--
  Copyright 2024 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page">
  <ground-header></ground-header>

  <h1 class="page-title">About</h1>

  <div class="container">
    <img class="logo" src="/assets/img/logo.svg" />

    <section>Ground is an open-source community project built by Google and FAO under the Forest Data Partnership with help from SIG, Ecam, and open-source community contributors.</section>

    <section>It is licensed under the <a href="https://www.apache.org/licenses/LICENSE-2.0" target="_blank">Apache License, Version 2.0</a>.</section>

    <section>Copyright 2024 <a href="https://github.com/google/ground-platform/blob/master/AUTHORS" target="_blank">The Ground Authors</a></section>

    <button
      mat-button
      color="primary"
      aria-label="back"
      class="back-button"
      (click)="onBackButtonClick()"
    >
      <mat-icon>arrow_back</mat-icon>

      <span>Back</span>
    </button>
  </div>
</div>